import { Select } from 'antd';
import { KANAL_AGACI } from './kanal';

const TUMU = '__tum__';

/**
 * Iki seviyeli kanal secimi: grup satiri secilebilir, alt kanallar girintili. Tek alt kanalli grupta
 * (Online) alt satir basilmaz. `virtual={false}`: on seceneklik liste sanal listeye kirpilmasin.
 */
export function KanalSecici({ value, onChange }: { value: string | null; onChange: (k: string | null) => void }) {
  const secenekler = [
    { value: TUMU, label: 'Tüm kanallar' },
    ...KANAL_AGACI.flatMap((g) => [
      { value: g.grup, label: g.grup },
      ...(g.kanallar.length > 1
        ? g.kanallar.map((k) => ({ value: k, label: <span className="pl-3">{k}</span> }))
        : []),
    ]),
  ];
  return (
    <div data-testid="kanal-secici">
      <Select
        size="small"
        style={{ minWidth: 150 }}
        virtual={false}
        value={value ?? TUMU}
        onChange={(v: string) => onChange(v === TUMU ? null : v)}
        options={secenekler}
      />
    </div>
  );
}
